import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

type Form = {
  motivo: string;
}
const FormMotivoRecusa = ({ onConfirm }: { onConfirm: (aceito: boolean, motivo?: string) => void }) => {
  const { formState: { errors }, handleSubmit, register } = useForm<Form>({
    defaultValues: {
      motivo: '0'
    }
  });

  const onSubmit = (data: Form) => {
    if(data.motivo === '0'){
      toast.error('Selecione um motivo!')
      return
    }

    onConfirm(false, data.motivo);
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <label htmlFor="motivo-recusa">Selecione o motivo da recusa:</label>
      <select
        id="motivo-recusa"
        className="form-control"
        aria-invalid={!!errors.motivo}
        {...register('motivo', {
          required: "Campo obrigatório!"
        })}
      >
        <option value="0">Selecione um motivo</option>
        <option value="1">Inviabilidade Financeira</option>
        <option value="2">Inviabilidade Técnica</option>
        <option value="3">Sem área para instalação</option>
        <option value="4">Parado por 30 dias</option>
        <option value="5">Sem contato com o cliente ou consultor</option>
        <option value="6">Cliente fechou com outra empresa</option>
        <option value="7">Consultor/Cliente recusou a proposta</option>
        <option value="8">Cliente desistiu</option>
        <option value="9">Cliente retomará a negociação em outra data</option>
        <option value="10">Cliente prosseguiu com outra proposta, duplicata</option>
        <option value="11">Outro</option>
      </select>
      {errors.motivo && <span className="text-danger">{errors.motivo}</span>}
      <button type="submit" className="btn btn-success mt-3">Confirmar Recusa</button>
    </form>
  );
};

export default FormMotivoRecusa;